export default {
    key: 'ski',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: '19fa6d77-9437-44a5-8c19-4184a16912b6',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: true,
    isUsingReductionCards: false,
    isUsingKeyCards: true,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: true,
    upsells: ['upsell-joch-winter', 'upsell-rental-ski'],
    salesTimeLimit: 1020, // 17:00
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: 'JB_SKI_PASS',
    listingId: '19fa6d77-9437-44a5-8c19-4184a16912b6',
    contentfulId: 'ski',
    steps: [],
} satisfies ProductConfigActivity;
